// eslint-disable-next-line consistent-default-export-name/default-import-match-filename
import ToggleSwitch from './ClientToggleSwitch'
export * from './types'
export { ToggleSwitch }
